import { constants, rem, Styles, theme } from '@/styles';

export const styles: Styles = {
  borderRadius: constants.borderRadius.small,
  border: `1px solid ${theme.borderPrimary}`,
  paddingLeft: constants.offset.medium,
  paddingRIght: constants.offset.medium,
  lineHeight: '36px',
  width: '100%',
  color: theme.textPrimary,
  transitionProperty: 'border-color, box-shadow',
  transitionDuration: '.2s',

  '&::placeholder': {
    fontStyle: 'italic',
    color: theme.textThird,
    fontSize: rem(constants.fontSize.medium),
  },

  '&:active:enabled, &:focus:enabled': {
    border: `1px solid ${theme.borderPrimaryActive}`,
    boxShadow: `0 0 1px 1px ${theme.borderPrimaryActive} inset`,
    outline: 'none',
  },

  '&:disabled': {
    backgroundColor: theme.backgroundPrimaryDisabled,
    color: theme.textDisabled,
    cursor: 'not-allowed',

    '&::placeholder': {
      color: theme.textDisabled,
    },
  },
};
